'use client'

import { useAuthContext } from '@/features/auth/contexts/AuthContext'
import { cn } from '@/shared/lib/utils'

import { authCtaClassName } from '../../constants/styles'

type SignUpButtonProps = React.ComponentProps<'button'>

export function SignUpButton({ children, className, ...props }: SignUpButtonProps) {
  const { isLoading } = useAuthContext()

  return (
    <button
      type="submit"
      disabled={isLoading}
      className={cn(authCtaClassName, className)}
      {...props}
    >
      {isLoading ? (
        <>
          <span className="animate-spin mr-2">
            <i className="fad fa-spinner-third" />
          </span>
          Criando conta...
        </>
      ) : (
        children ?? 'Criar conta'
      )}
    </button>
  )
}
